<template>
  <div>
    <v-card flat class="card-bg">
      <v-card flat class="ma-4 rounded-20">
        <v-card-title class="title-font">
          NOTIFICATIONS
          <v-spacer />
          <v-btn class="my-auto" icon @click="setShowNotifications(false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </v-card>

      <v-card
        flat
        class="ma-4 rounded-20"
        v-for="notification in _notifications"
        :key="notification.uid"
      >
        <v-card-title>
          <small class="title-font">
            {{ notification.notification_type.replaceAll("_", " ") }}
          </small>
          <v-spacer />
          <div>
            <v-icon class="me-1">mdi-clock-outline</v-icon>
            <small>
              {{
                notification.delivered_at | luxon({ output: { format: "med" } })
              }}
            </small>
          </div>
        </v-card-title>
        <v-card-subtitle class="">
          <v-row>
            <v-col cols="8" class="align-self-center">
              {{ notification.message }}
            </v-col>
            <v-col cols="4" align="end">
              <v-btn
                class="btn-primary me-3"
                small
                @click="openNotification(notification)"
              >
                Open
              </v-btn>
              <v-btn class="btn-error" small @click="dismiss(notification)">
                Dismiss
              </v-btn>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col
              cols="3"
              v-for="detail in notification.details"
              :key="`${detail.text}-${notification.uid}`"
            >
              <v-icon class="me-1"> {{ detail.icon }} </v-icon>
              {{ detail.text }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import client from "@/lib/ApiClient"

const messageMap = {
  RETURNED_FILE: "You have received a file from Osteon"
}

export default {
  name: "NotificationsList",

  date() {
    return {}
  },

  computed: {
    ...mapGetters(["notifications", "inboxItems"]),

    _notifications() {
      return this.notifications.map((n) => {
        return {
          uid: n.uid,
          notification_type: n.notification_type,
          message: messageMap[n.notification_type],
          delivered_at: n.delivered_at,
          payload: n.payload
        }
      })
    }
  },

  methods: {
    ...mapActions([
      "setNotifications",
      "setShowNotifications",
      "setSelectedOrder",
    ]),

    async openNotification(notification) {
      await client.instance.notifications.dismissNotification(notification.uid)

      this.setNotifications(
        this.notifications.filter((n) => n.uid !== notification.uid)
      )

      if (notification.notification_type === "RETURNED_FILE") {
        const order = this.inboxItems.find(
          (i) => i.uid === notification.payload.order_uid
        )
        this.setSelectedOrder(order)
        this.$router.push({
          name: "caseView",
          query: {
            tab: "overview"
          },
          params: {
            uid: notification.payload.order_uid,
            session_uid: notification.payload.order_session_uid
          }
        })
      }
    },

    async dismiss(notification) {
      await client.instance.notifications.dismissNotification(notification.uid)

      this.setNotifications(
        this.notifications.filter((n) => n.uid !== notification.uid)
      )

      if (this.notifications.length === 0) this.setShowNotifications(false)
    }
  }
}
</script>
